module.exports = __webpack_public_path__ + "img/128.23f85946.svg";